import { UserDetailsModel } from '@/features/auth/types/models/user-details.model'
import { UserMessagesModel } from '@/features/auth/types/models/user.model'
import { create } from 'zustand'

type AuthState = {
  user: UserDetailsModel | null
  status: 'authenticated' | 'unauthenticated' | 'pending'
  isAuthenticated: boolean
  messages: UserMessagesModel[]
  setUser: (user: UserDetailsModel, messages?: UserMessagesModel[]) => void
  clearUser: () => void
}

export const useAuth = create<AuthState>(set => ({
  user: null,
  accountType: null,
  isAuthenticated: false,
  status: 'pending',
  messages: [],
  setUser: (user, messages) =>
    set({
      user,
      isAuthenticated: true,
      messages,
      status: 'authenticated',
    }),
  clearUser: () =>
    set({
      user: null,
      isAuthenticated: false,
      status: 'unauthenticated',
    }),
}))
